export default __webpack_public_path__ + "static/media/24.09f8f61a.png";